export enum GameModeEnum {
    Login,
    Lobby,
    Day,
    Night,
    Dead,
    End
}